/* eslint-disable */
export const allDataSet = (state) => {
  return state.dataSet;
};

export const lng = (state) => {
  return state.lng;
};

export const getContent = (state) => {
  return state.lng === 'en' ? state.content.en : state.content.ua;
};



// WEBPACK FOOTER //
// ./src/store/getters.js